import React, { useContext, useEffect, useState } from "react";
import {mock, headerRouterTable} from "./utils"
import {
    Table,
    HeaderRow,
    ItemRow,
    HeaderCell,
    ItemCell,
    ItemCellContainer,
    ImageCell,
    OptionsImage,
    StatusText
}from "./style"

import details from '../../../../assets/router/details.svg';
import edit from '../../../../assets/router/edit-pen.svg';
import trash from '../../../../assets/router/trash.svg';
import { RouterContext } from "../../../../contexts/RouterContext";
import SectionContext from "../../../../contexts/SectionContext";
import ModalContext from "../../../../contexts/ModalContext";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import { RouterOutletType } from "../index2";
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr } from "../../../../components/styles/table-style";
import { FeedbackContext } from "../../../../contexts/FeedbackContext";

interface routerTableType {
    onChange?: () => void
}

const RouterTable: React.FC<routerTableType> = (props)=>{
    const dataFormatter = (isoDateString: string): string => {
        if (!isoDateString) {
            return ''; // Retorna vazio se a string for nula ou vazia
        }
    
        const dateUtc = new Date(isoDateString);
    
        // Verifica se a data é válida antes de tentar formatar
        if (isNaN(dateUtc.getTime())) {
            console.error("Data ISO inválida recebida:", isoDateString);
            return ''; // Trata o caso de uma string de data inválida
        }
    
        // Extrai as partes da data diretamente do UTC
        const year = dateUtc.getUTCFullYear();
        const month = dateUtc.getUTCMonth() + 1; // getUTCMonth é 0-indexado, então adiciona 1
        const day = dateUtc.getUTCDate();
    
        // Garante que mês e dia tenham dois dígitos (ex: 01 em vez de 1)
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
    
        return `${formattedDay}/${formattedMonth}/${year}`;
    };
    const {router, setRouter} = useContext(RouterContext)
    const {setModalActive, setModalSection} = useContext(ModalContext)
    const {routerSection, setRouterSection} = useContext(SectionContext)
    const [routes, setRoutes] = useState<any>([])
    
    const { setFeedback } = useContext(FeedbackContext)
    const { setTabIndex } = useOutletContext<RouterOutletType>()
    const navigate = useNavigate() 
  useEffect(() => {
    setTabIndex(1)
    setRouterSection('router')
  }, [])
    const handleEdit = (id: number)=>{
        getRoute(id)
        setRouterSection('newRouter');
        setRouter(router)
        navigate('/panel/router/routers/edit')
    } 
    const handleView = async (id: number)=>{
        getRoute(id)
        // setModalSection('routerRouteDetail')
        // setModalActive(true)
        setRouter(router)
        navigate(`${id}`)
    }
    const deleteRoute = async (id: number)=>{
        try{
            await axios.delete(`${process.env.REACT_APP_ROUTER_BASE_URL}/route/${id}`)
            getRoutes();
            setFeedback({
                isOpen:true,
                message:'Rota deletada!',
                statusOk:true
              })
        }catch{
            setFeedback({
                isOpen:true,
                message:'Erro ao deletar rota!',
                statusOk:false
              })
        }
    }
    
    const getRoute = async (id: number)=>{
        const response = await axios.get(`${process.env.REACT_APP_ROUTER_BASE_URL}/route/${id}`)
        const route = await response.data
        console.log(response.data)
        setRouter(route)
        console.log(router)
    }
    const getRoutes = async ()=>{
            const response = await axios.get(`${process.env.REACT_APP_ROUTER_BASE_URL}/route`)
            const routes = await response.data
            setRoutes(routes)
        }

    useEffect(()=>{
        const getRoutes = async ()=>{
            const response = await axios.get(`${process.env.REACT_APP_ROUTER_BASE_URL}/route`)
            const routes = await response.data
            setRoutes(routes)
        }
        getRoutes()
    })
    const mapStatus = (status: string): string => {
        if (status === 'A programar') return 'pending';
        if (status === 'Rota programada') return 'pending';
        if (status === 'Rota cancelado') return 'cancel';
        if (status === 'Rota concluida' ) return 'completed';
        return status; // Retorna o status original caso não se encaixe nas condições
    };
    return(
        <>
        <GlobalTable>
            <thead>
                <HeaderLine>
                    {headerRouterTable.map((header)=>(
                        <Th key={header}>{header}</Th>
                    ))}
                    <Th></Th>
                </HeaderLine>
                </thead>
                <tbody>
                {routes.map((router: any)=>(
                    <Tr key={router.id}>
                        <Td key={router.id}>{router.id}</Td>
                        <Td key={router.origin}>{router.origin}</Td>
                        <Td key={router.status}> <StatusText className={mapStatus(router.status)}>{router.status}</StatusText> </Td>
                        <Td key={router.vehicle}>{router.vehicle.plate}</Td>
                        <Td key={router.date}>{dataFormatter(router.date)}</Td>
                        <Td key={router.track}>{router.track ? router.track : "-"}</Td>
                        <TdButtons>
                        <OptionsImage onClick={async ()=> await handleView(router.id)}src={details}alt='Icon to show router'/>
                        <OptionsImage onClick={async ()=> await handleEdit(router.id)} src={edit}alt='Icon to edit router'/>
                        <OptionsImage onClick={async ()=> await deleteRoute(router.id)} src={trash}alt='Icon to delet router'/>
                        </TdButtons>
                       
                    </Tr>
                ))}
      </tbody>
        </GlobalTable>
        </>
    )

}

export default RouterTable;